import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=49a4ee2a&scoped=true&"
import script from "./TagsList.vue?vue&type=script&lang=js&"
export * from "./TagsList.vue?vue&type=script&lang=js&"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=49a4ee2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a4ee2a",
  null
  
)

export default component.exports